import { useEffect } from 'react';
import { bridge, isApp } from 'shared/src/utils';
import { useGoodsRoute } from '../../../hooks/useGoodsRoute';

export const useReportTTFD = () => {
  const { instanceId } = useGoodsRoute<'RecentlyViewedGoods'>();

  useEffect(() => {
    if (!instanceId) {
      return;
    }
    if (isApp()) {
      bridge.reportTTFD({ instanceId });
    }
  }, [instanceId]);
};
